export const CognitiveVerifier = {
  isInstructorStudent(user) {
    return user && user.studentType === 'INSTRUCTOR';
  },

  isPublicStudent(user) {
    return !user || user.studentType === 'PUBLIC' || !user.studentType;
  },

  canViewResults(user) {
    return this.isInstructorStudent(user);
  },

  canSubmitAssignment(user) {
    return this.isInstructorStudent(user);
  },

  canAccessCertificate(user) {
    return this.isInstructorStudent(user);
  },

  canAttemptExam(user) {
    return true; // Both can attempt, but submission storage and release vary
  },

  canViewTeacherFeedback(user) {
    return this.isInstructorStudent(user);
  },

  canAccessSkillModule(user, skillName) {
    // Public students can view lessons/practice preview; instructor students have full access
    return true; 
  },

  getNormalizedPermissions(user) {
    return {
      canViewResults: this.canViewResults(user),
      canSubmitAssignment: this.canSubmitAssignment(user),
      canAccessCertificate: this.canAccessCertificate(user),
      canAttemptExam: this.canAttemptExam(user),
      canViewTeacherFeedback: this.canViewTeacherFeedback(user),
      studentType: user?.studentType || 'PUBLIC'
    };
  }
};